;( function( $, undefined )
{

    $.fn.SiteCatalystPrivateMessages = function( siteCat )
    {
        var that = siteCat;

        var trackComposePmIntent = function()
        {
            $( '.lia-button-Submit-action' ).on( 'click', function()
            {
                that.track( 'Send PM', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'tab:compose new message:privatenotespage:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackReplyButton = function()
        {
            $( '#pdc6-button-reply' ).on( 'click', function()
            {
                that.track( 'PM reply intent', {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:private message reply:null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        var trackAddContact = function()
        {
            $( '.fav-user' ).find( 'a' ).on( 'click', function()
            {
                var removeContact = $( this ).attr( 'href' ).indexOf( 'deletefriend' ) != -1
                  , title         = removeContact ? 'Remove contact' : 'Add contact'
                  , button        = removeContact ? 'remove contact' : 'add contact';

                that.track( title, {
                    type   : that.eventType.other,
                    vars   : {
                        prop49 : 'button:' + button + ':null:' + that.pageName,
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );
            } );
        };

        if( siteCat.$mainContainer.hasClass( 'user-messages-compose' ) )
        {
            trackComposePmIntent();
        }
        else if( siteCat.$mainContainer.hasClass( 'user-messages-detail' ) )
        {
            trackReplyButton();
            trackAddContact();
        }

        $( '#pdc6-button-new-message' ).on( 'click', function()
        {
            siteCat.track( 'New message', {
                type   : siteCat.eventType.other,
                vars   : {
                    prop49 : 'tab:intent to send new message:privatenotespage:' + siteCat.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );
    };

} )( jQuery );